<template>
  <article>
    <div>
      <v-tooltip bottom :close-delay="500" allow-overflow >
        <v-chip
          slot="activator"
          small
          color="indigo darken-1"
          text-color="white"
          @click.native="openTabelaInfAd()"
          class="infAdChip">
            Visualizar
        </v-chip>
        <span>Visualizar informações adicionais</span>
      </v-tooltip>
    </div>
    <v-dialog @keydown.esc="openDialog = false" v-model="openDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span>
            <strong>Informações adicionais</strong>
          </span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="openDialog=false">
            <v-icon color="red">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              {{ this.item.item.inf_ad }}
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </article>
</template>
<script>
export default {
  props: ["item"],
  beforeMount() {},
  data: () => ({
    openDialog: false,
  }),
  methods: {
    openTabelaInfAd: function() {
      this.openDialog = true;
    },
  },
};
</script>
<style>
.infAdChip span.v-chip__content {
  cursor: pointer!important;
  font-size: 0.85rem!important;
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_infAd/Coluna_infAd.vue